import {ModelProperty} from '../../engine/model-property';
import {PropertyGroup} from '../../engine/property-group';

export class FormColumn {
  public display = false;
  public index: number;
  public groups: PropertyGroup[];
  public baseGroups: PropertyGroup[];
  public noGroup: PropertyGroup = new PropertyGroup(null, null);
  public properties: ModelProperty[] = [];

  constructor(index: number) {
    this.index = index;
  }

  public push(prop: ModelProperty) {
    this.properties.push(prop);
    if (prop.showOnForm) {
      this.display = true;
    }
    this.pushOnGroup(prop);
  }

  public generateGroups() {
    this.groups = this.baseGroups ?? [];
    this.noGroup = new PropertyGroup(null, null);
    for (const prop of this.properties) {
      this.pushOnGroup(prop);
    }
    this.groups.push(this.noGroup);
  }

  reload() {
    this.generateGroups();
    this.checkDisplay();
  }

  checkDisplay() {
    this.display = !!this.properties.find((p) => p.showOnForm);
  }

  private pushOnGroup(prop: ModelProperty) {
    if (prop.formGroup) {
      const group = this.groups.find((gr) => gr.id === prop.formGroup);
      if (group) {
        group.addProperty(prop);
      } else {
        const gr = new PropertyGroup(prop.formGroup, prop.formGroup);
        gr.properties = [prop];
        this.groups.push(gr);
      }
    } else {
      this.noGroup.addProperty(prop);
    }
  }
}
